import { Navigate } from "react-router-dom"
import { useAuth } from "./../../hooks/useAuth"

export function ProtectedRoute({ redirectPath = "/login", children }) {
   const { authenticated, loading } = useAuth()

   if (loading) {
      return null // ou <Loader />
   }

   if (!authenticated) {
      return <Navigate to={redirectPath} replace />
   }

   return children
}
